import { type AssociationType } from '@/portal-api.definition';
import { ChevronRight, Email, Loader, Smartphone } from '@nosinovacao/fe-icons';
import { Captcha, If, ListItem, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type JSX, useState } from 'react';
import { useServicesContext } from './context';
import { useSendAccountAssociationCode } from '@/hooks/api/account-association.hooks';

const iconForOption: Record<AssociationType, JSX.Element> = {
  Phone: <Smartphone width={24} height={24} />,
  Email: <Email width={24} height={24} />,
  Nif: <></>,
  Passport: <></>,
};

export function ServicesNavSheetContactSelectionContent() {
  const { t } = useI18n();
  const { flowData, setFlow } = useServicesContext();
  const contacts = flowData.contactSelectionContacts;
  const [loadingContact, setLoadingContact] = useState<string | null>(null);
  const { mutateAsync: sendCode, captcha } = useSendAccountAssociationCode();
  async function handleContactSelected(id: number, type: AssociationType) {
    if (captcha.challenge && !captcha.token) return;
    try {
      setLoadingContact(type);
      await sendCode({
        captcha,
        contactId: id,
        targetId: flowData.selectedContact,
        type: flowData.associationType,
      });
      setFlow('code-input', {
        ...flowData,
        contactId: id,
      });
    } finally {
      setLoadingContact(null);
    }
  }
  return (
    <div className="flex size-full flex-col gap-4">
      {contacts.map((contact) => (
        <ListItem
          disabled={loadingContact !== null}
          key={contact.Id}
          skin="light"
          title={t(`Services.AddServices.ContactSelection.${contact.Type}`)}
          leadingIcon={iconForOption[contact.Type]}
          onClick={() => handleContactSelected(contact.Id, contact.Type)}
          trailingIcon={
            loadingContact === contact.Type ? (
              <Loader height={24} width={24} />
            ) : (
              <ChevronRight width={24} height={24} />
            )
          }
          data-tid={`button-${contact.Type.toLowerCase()}`}
        />
      ))}
      <If condition={captcha.challenge}>
        <Captcha onChange={captcha.setToken} />
      </If>
    </div>
  );
}
